module.exports = __webpack_public_path__ + "img/westervelt-logo.4802505c.jpg";